export default __webpack_public_path__ + "static/media/fenoximetylpenicillin.33599157.png";